<template>
  <div id="module-builder" class="elements">
    <component
      v-for="(module, i) in modules"
      v-bind:is="currentModule(module).component"
      :data="currentModule(module).data"
      :key="i"
    ></component>
  </div>
</template>

<script>
import BuilderModules from "@/components/modules/";

export default {
  name: "module-builder",
  props: ["modules"],
  data() {
    return {
      BuilderModules
    };
  },
  methods: {
    currentModule(acfModule) {
      let moduleName = acfModule.acf_fc_layout;
      // Because I missnamed module files and acf modules in ACF fields
      // Ideally Acf module name should be equal to file name
      switch (moduleName) {
        case "logo_box":
          moduleName = "logoBox";
          break;
        case "vimeo_gallery":
          moduleName = "vimeoGallery";
          break;
        case "vimeo_carousel":
          moduleName = "vimeoCarousel";
          break;
        case "single_event":
          moduleName = "singleEvent";
          break;
        case "text_block":
          moduleName = "textBlock";
          break;
        case "text_image":
          moduleName = "textImage";
          break;
        case "cta_with_form":
          moduleName = "ctaWithForm";
          break;
      }
      const component = BuilderModules[moduleName]
        ? BuilderModules[moduleName]
        : BuilderModules["noModule"];

      return { component, data: acfModule };
    }
  },
  computed: {},
  components: {}
};
</script>

<style lang="scss">
#module-builder {
  position: relative;
  z-index: 10;
}
</style>
